import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HeaderArrowWrapper = styled.div`
  margin-left: ${Spacing.S8};
`

export const DividerWrapper = styled.div`
  display: flex;
  margin-right: ${Spacing.S32};
  margin-left: ${Spacing.S32};
`

export const ReceiptPanelsWrapper = styled.div`
  padding-right: ${Spacing.S80};
  padding-left: ${Spacing.S80};
`
